// extracted by mini-css-extract-plugin
export default {"container":"Body__container___bYcLc"};